import { createContext } from 'react';

/**
 * React context for reCAPTCHA v3 integration
 */ const RecaptchaContext = createContext(null);

export { RecaptchaContext };
//# sourceMappingURL=RecaptchaContext.js.map
